import Vue from 'vue';
import Router from 'vue-router';

import { loggedIn } from '@mobile/services/user';
import TodosInspections from '@mobile/views/Todos/Inspections.vue';
import TodosIssues from '@mobile/views/Todos/Issues.vue';
import Checklists from '@mobile/views/Checklists/Checklists.vue';
import Drafts from '@mobile/views/Checklists/Drafts.vue';
import Login from '@mobile/views/Login.vue';
import Device from '@mobile/views/Device.vue';
import Profile from '@mobile/views/Profile.vue';
import ConductInspection from '@mobile/views/ConductInspection/ConductInspection.vue';
import Inspections from '@mobile/views/Checklists/Inspections.vue';
import InspectionReport from '@mobile/views/Checklists/InspectionReport.vue';
import PasswordReset from '@mobile/views/PasswordReset.vue';
import PasswordResetLinkRequest from '@mobile/views/PasswordResetLinkRequest.vue';
import Notifications from '@mobile/views/Notifications/Notifications.vue';
import Issues from '@mobile/views/Issues/Index.vue';
import RaiseIssue from '@mobile/views/Issues/Create.vue';
import EditIssue from '@mobile/views/Issues/Edit.vue';
import { ISSUE_STATUS } from '@/constants';

Vue.use(Router);

export default function create() {
    const router = new Router({
        routes: [
            {
                path: '/',
                redirect: { name: 'todos' },
            },
            {
                path: '/todos',
                name: 'todos',
                component: TodosInspections,
            },
            {
                path: '/todos/issues',
                name: 'todos-issues',
                component: TodosIssues,
                meta: {
                    notOnFreePlan: false,
                    message: {
                        advice: window.i18n.t('Upgrade on desktop to solve detected issues faster. With our this feature you can:'),
                        list: [
                            window.i18n.t('Report issues within and outside of inspections'),
                            window.i18n.t('Assign corrective actions'),
                            window.i18n.t('Notify assignee'),
                            window.i18n.t('Add a schedules'),
                            window.i18n.t('Add photos'),
                            window.i18n.t('Set a priority'),
                            window.i18n.t('Mark corrective actions as "in progress" or "done"'),
                            window.i18n.t('Get an overview of all issues'),
                        ],
                    },
                },
            },
            {
                path: '/login',
                name: 'login',
                component: Login,
                meta: {
                    guest: true,
                },
            },
            {
                path: '/password/reset',
                name: 'password-reset-link-request',
                component: PasswordResetLinkRequest,
                meta: {
                    guest: true,
                },
            },
            {
                path: '/password/reset/:email/:token',
                name: 'password-reset',
                component: PasswordReset,
                props: (route) => ({
                    token: route.params.token,
                    encodedEmail: route.params.email,
                }),
                meta: {
                    guest: true,
                },
            },
            {
                path: '/checks',
                name: 'checklists',
                component: Checklists,
            },
            {
                path: '/checks/started',
                name: 'drafts',
                component: Drafts,
            },
            {
                path: '/checks/done',
                name: 'done-inspections',
                component: Inspections,
            },
            {
                path: '/checks/done/:inspectionId',
                name: 'done-inspection',
                component: InspectionReport,
                props: (route) => ({
                    inspectionId: parseInt(route.params.inspectionId, 10),
                }),
            },
            {
                path: '/more/device',
                name: 'device',
                component: Device,
            },
            {
                path: '/more/profile',
                name: 'profile',
                component: Profile,
            },
            {
                path: '/conduct/:type/:resourceId',
                name: 'conduct',
                component: ConductInspection,
                props: (route) => ({
                    resourceId: parseInt(route.params.resourceId, 10),
                    type: route.params.type,
                }),
            },
            // Notifications
            {
                path: '/notifications',
                name: 'notifications',
                component: Notifications,
            },
            {
                path: '/notifications/:notificationId',
                name: 'notification',
                component: Notifications,
                props: (route) => ({
                    notificationId: parseInt(route.params.notificationId, 10),
                }),
            },
            {
                path: '/issues',
                name: 'issues',
                component: Issues,
                meta: {
                    notOnFreePlan: false,
                    message: {
                        advice: window.i18n.t('Upgrade on desktop to solve detected issues faster. With our this feature you can:'),
                        list: [
                            window.i18n.t('Report issues within and outside of inspections'),
                            window.i18n.t('Assign corrective actions'),
                            window.i18n.t('Notify assignee'),
                            window.i18n.t('Add a schedules'),
                            window.i18n.t('Add photos'),
                            window.i18n.t('Set a priority'),
                            window.i18n.t('Mark corrective actions as "in progress" or "done"'),
                            window.i18n.t('Get an overview of all issues'),
                        ],
                    },
                },
            },
            {
                path: '/issues/solved',
                name: 'issues-solved',
                component: Issues,
                props: () => ({
                    status: ISSUE_STATUS.SOLVED+','+ISSUE_STATUS.CANT_DO,
                }),
                meta: {
                    notOnFreePlan: false,
                    message: {
                        advice: window.i18n.t('Upgrade on desktop to solve detected issues faster. With our this feature you can:'),
                        list: [
                            window.i18n.t('Report issues within and outside of inspections'),
                            window.i18n.t('Assign corrective actions'),
                            window.i18n.t('Notify assignee'),
                            window.i18n.t('Add a schedules'),
                            window.i18n.t('Add photos'),
                            window.i18n.t('Set a priority'),
                            window.i18n.t('Mark corrective actions as "in progress" or "done"'),
                            window.i18n.t('Get an overview of all issues'),
                        ],
                    },
                },
            },
            {
                path: '/issues/raise',
                name: 'issues-raise',
                component: RaiseIssue,
                meta: {
                    notOnFreePlan: false,
                    message: {
                        advice: window.i18n.t('Upgrade on desktop to solve detected issues faster. With our this feature you can:'),
                        list: [
                            window.i18n.t('Report issues within and outside of inspections'),
                            window.i18n.t('Assign corrective actions'),
                            window.i18n.t('Notify assignee'),
                            window.i18n.t('Add a schedules'),
                            window.i18n.t('Add photos'),
                            window.i18n.t('Set a priority'),
                            window.i18n.t('Mark corrective actions as "in progress" or "done"'),
                            window.i18n.t('Get an overview of all issues'),
                        ],
                    },
                },
            },
            {
                path: '/issues/edit/:id',
                name: 'issues-edit',
                component: EditIssue,
                props: (route) => ({
                    id: parseInt(route.params.id, 10),
                }),
                meta: {
                    notOnFreePlan: false,
                    message: {
                        advice: window.i18n.t('Upgrade on desktop to solve detected issues faster. With our this feature you can:'),
                        list: [
                            window.i18n.t('Report issues within and outside of inspections'),
                            window.i18n.t('Assign corrective actions'),
                            window.i18n.t('Notify assignee'),
                            window.i18n.t('Add a schedules'),
                            window.i18n.t('Add photos'),
                            window.i18n.t('Set a priority'),
                            window.i18n.t('Mark corrective actions as "in progress" or "done"'),
                            window.i18n.t('Get an overview of all issues'),
                        ],
                    },
                },
            },


        ],
    });

    router.beforeEach((to, from, next) => {
        if (window.serviceWorkerRegistration) {
            console.log('trying to update service worker on route change');
            window.serviceWorkerRegistration
                .update()
                .catch(() => {});
        }

        if (to.matched.some((record) => (!record.meta || record.meta.guest !== true))) {
            if (loggedIn()) {
                next();
            } else {
                router.replace({
                    name: 'login',
                    query: { nextUrl: to.fullPath },
                });
            }
        }
        next();
    });

    return router;
}
